/* eslint-disable react/react-in-jsx-scope */
import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import CoveragePrints from './CoveragePrint';

const MediaLayout = () => (
  <Box width="100%" mb="100px">
    <Box bg="#197542" py="80px" w="100%">
      <Text
        fontWeight="700"
        fontSize={{ xs: '26px', md: '48px' }}
        lineHeight="130%"
        color="#fff"
        textAlign="center"
      >
        Media Coverage
      </Text>
    </Box>
    <CoveragePrints />
  </Box>
);

export default MediaLayout;
